/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Referral_Access_DescriptionInputs */

const en_plan_referral_access_description = /** @type {(inputs: Plan_Referral_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Listening access is covered by the referral program.`)
};

const es_plan_referral_access_description = /** @type {(inputs: Plan_Referral_Access_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu acceso a Listening está cubierto por el programa de referidos.`)
};

/**
* | output |
* | --- |
* | "Your Listening access is covered by the referral program." |
*
* @param {Plan_Referral_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_referral_access_description = /** @type {((inputs?: Plan_Referral_Access_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Referral_Access_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_referral_access_description(inputs)
	return en_plan_referral_access_description(inputs)
});